import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  getAllRichTextsForStep,
  getAllAttachmentsForStep,
  getAllFormsForStep,
  getAllVideosForStep,
  getAllCanvasesForStep,
} from '../../../../../redux/stepSlice'
import ChildrenRenderer from '../../../../Documents/components/Nodes/ChildrenRenderer'
import Loader from '../../../../../common/Loader'

const PreviewSubStep = ({version_content}) => {
  const { short_description, substep_label } = version_content
  const dispatch = useDispatch()
  const [children, setChildren] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  
  useEffect(() => {
    const fetchChildrenData = async () => {
      const substepId = version_content.sub_step_tree_node_id
      const stepId = version_content.step_id_ref
      const sectionId = version_content.section_id_ref
      const partId = version_content.part_id_ref
      const revisionId = version_content.revision_id_ref
      
      if (substepId && stepId && sectionId && partId && revisionId) {
        setIsLoading(true)
        try {
          // Fetch all children nodes for this substep
          const [richTextsResp, attachmentsResp, formsResp, videosResp, canvasesResp] = await Promise.all([
            dispatch(getAllRichTextsForStep({ partId, revisionId, sectionId, stepId, substepId })),
            dispatch(getAllAttachmentsForStep({ partId, revisionId, sectionId, stepId, substepId })),
            dispatch(getAllFormsForStep({ partId, revisionId, sectionId, stepId, substepId })),
            dispatch(getAllVideosForStep({ partId, revisionId, sectionId, stepId, substepId })),
            dispatch(getAllCanvasesForStep({ partId, revisionId, sectionId, stepId, substepId })),
          ])
          
          const childrenData = [
            ...(richTextsResp.payload?.data || []).map(item => ({ ...item, type: 'richText' })),
            ...(attachmentsResp.payload?.data || []).map(item => ({ ...item, type: 'attachment' })),
            ...(formsResp.payload?.data || []).map(item => ({ ...item, type: 'form' })),
            ...(videosResp.payload?.data || []).map(item => ({ ...item, type: 'video' })),
            ...(canvasesResp.payload?.data || []).map(item => ({ ...item, type: 'canvas' })),
          ]
          
          setChildren(childrenData)
        } catch (error) {
          console.error('Error fetching substep children:', error)
        } finally {
          setIsLoading(false)
        }
      }
    }
    
    fetchChildrenData()
  }, [dispatch, version_content])
  
  if (isLoading) {
    return <Loader text="Loading substep data..." />
  }
  
  // Use substep_label if available, otherwise construct it
  const substepLabel = substep_label || version_content.pageTitle || 'Substep'
  
  return (
    <div>
      <div style={{ padding: '20px' }}>
        {/* Substep Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '20px',
            paddingBottom: '20px',
            borderBottom: '3px double #e0e0e0',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input type="checkbox" defaultChecked={true} readOnly disabled />
            <h2 style={{ margin: 0, fontSize: '23px' }}>{substepLabel}</h2>
          </div>
        </div>

        {/* Substep Description */}
        {short_description && (
          <p style={{ marginLeft: '5px', whiteSpace: 'pre-wrap' }}>
            {short_description}
          </p>
        )}

        {/* Substep Children (Rich Text, Video, Form, Canvas, Attachment) */}
        {children && children.length > 0 && (
          <div style={{ marginTop: '20px' }}>
            <ChildrenRenderer
              children={children}
              parentContext={{
                sectionIndex: 0,
                stepIndex: 0,
                substepIndex: 0,
                globalStepNumber: 1,
                sectionHeading: version_content.section || 'Section',
                sectionId: version_content.section_id_ref,
                stepId: version_content.step_id_ref,
                substepId: version_content.sub_step_tree_node_id,
                partNumber: version_content.partNumber,
                revision: version_content.revision,
                partId: version_content.part_id_ref,
                revisionId: version_content.revision_id_ref,
              }}
              onNavigate={() => {}}
              checkboxState={{
                currentNodeId: version_content.sub_step_tree_node_id,
                currentNodeType: 'substep',
                allChildrenChecked: true,
                allChildrenDisabled: true,
              }}
              disabled={true}
              allNodesData={[]}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default PreviewSubStep